import axios from "axios";

const api = axios.create({
  baseURL:
    process.env.GATSBY_API_URL ||
    "https://apimeuambiente.guararapes.com.br",
});

api.interceptors.request.use(
  config => {
    if (typeof window !== "undefined") {
      const stored = localStorage.getItem("@accessToken");

      if (stored) {
        const { token } = JSON.parse(stored);

        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
    }

    return config;
  },
  error => Promise.reject(error)
);

export default api;
